

























import { Vue, Component, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';

@Component({
    components: {}
})
export default class AddRobotGuideModal extends Vue {
    @State(state => state.cti.env)
    env: string;
    @Prop({ default: false })
    visible: boolean;
    @Prop({})
    groupId: number;
    @Prop({ default: false })
    isRgReport: boolean;

    btnLoading: boolean = false;

    close() {
        this.$emit('update:visible', false);
    }

    get url() {
        return this.env === 'test'
            ? `//xm-web.it.test.sankuai.com/bridge/chat?gid=${this.groupId}`
            : `//x.sankuai.com/bridge/chat?gid=${this.groupId}`;
    }
}
